export default __webpack_public_path__ + "static/media/YT.850e8984.svg";